var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0C9D61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_15420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83008 11.9212L9.98008 15.0712L16.73 8.32129",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_15420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2727,
    height: 15.2727,
    fill: "white",
    transform: "translate(4.36719 4.3645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterLike);
export default __webpack_public_path__ + "static/media/afterLike.015b7cfc61fd9f2161d9a03909f20e77.svg";
export { ForwardRef as ReactComponent };